import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useSystemSettings } from "@/hooks/useSystemSettings";

export const MaintenanceBanner = () => {
  const { data: settings } = useSystemSettings();

  if (!settings?.maintenance_mode) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Maintenance Mode</AlertTitle>
      <AlertDescription>
        The system is currently undergoing maintenance. Some features may be temporarily unavailable.
      </AlertDescription>
    </Alert>
  );
};
